import { render, staticRenderFns } from "./BroadcastBox.vue?vue&type=template&id=d226ef16&scoped=true"
import script from "./BroadcastBox.vue?vue&type=script&lang=js"
export * from "./BroadcastBox.vue?vue&type=script&lang=js"
import style0 from "./BroadcastBox.vue?vue&type=style&index=0&id=d226ef16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d226ef16",
  null
  
)

export default component.exports